
export const TOKEN_NAME= process.env.NEXT_PUBLIC_TOKEN_NAME || 'AKRE'
export const OFFSET_DEFAULT:number = 1;
export const LIMIT_DEFAULT:number = 25;